module.exports = __webpack_public_path__ + "img/content.f754a66f.jpg";